import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';

import { Avatar, FormLabel, Tooltip } from '@mui/material';

import { ImagePlus } from 'lucide-react';

import { COLORS } from '../../../../Constant/COLORS';

const ImageInput = React.forwardRef(
  ({ tooltip, thumbnail: Thumbnail, avatarProps }, ref) => {
    const id = useId();

    const [image, setImage] = useState(null);

    function handleChange({ target: { files } }) {
      const image = Array.from(files).at(0);
      setImage(image ? URL.createObjectURL(image) : null);
    }

    return (
      <>
        <FormLabel htmlFor={id} sx={{ cursor: 'pointer' }}>
          <Tooltip title={tooltip} placement='right-end'>
            <Avatar
              src={image || undefined}
              {...avatarProps}
              sx={{
                width: 100,
                height: 100,
                bgcolor: image ? undefined : COLORS.tealSoft,
                color: COLORS.teal,
                border: image ? 'none' : `2px dashed ${COLORS.grey1}`,
                transition: 'border-color .2s ease, background-color .2s ease',
                '&:hover': {
                  borderColor: COLORS.teal,
                  bgcolor: image ? undefined : COLORS.surfaceAlt,
                },
              }}
            >
              {!image &&
                (Thumbnail ? (
                  <Thumbnail sx={{ fontSize: '50px' }} />
                ) : (
                  <ImagePlus size={30} strokeWidth={1.6} />
                ))}
            </Avatar>
          </Tooltip>
        </FormLabel>
        <input
          id={id}
          accept='.png,.jpeg,.jpg'
          type='file'
          style={{ display: 'none', visibility: 'hidden', opacity: '0' }}
          ref={ref}
          onChange={handleChange}
        />
      </>
    );
  }
);

ImageInput.propTypes = {
  tooltip: PropTypes.string.isRequired,
  thumbnail: PropTypes.any,
  avatarProps: PropTypes.object,
};

export default React.memo(ImageInput);
